export type FitMode = "contain" | "cover" | "stretch";
export interface Box { x: number; y: number; w: number; h: number }
export interface FitResult {
  place: Box;
  crop?: { sx: number; sy: number; sw: number; sh: number };
}

/**
 * Given a source image (iw x ih) and a target box, compute where to place the
 * picture and (for "cover") which source rectangle to crop to.
 *  - stretch: fill the box (image distorts to the box aspect). Back-compat default.
 *  - contain: whole image, preserved aspect, centered inside the box (letterbox).
 *  - cover:   fill the box, preserved aspect, center-crop the overflow.
 */
export function computeImageFit(iw: number, ih: number, box: Box, mode: FitMode): FitResult {
  if (mode === "stretch" || iw <= 0 || ih <= 0) {
    return { place: { ...box } };
  }
  if (mode === "contain") {
    const scale = Math.min(box.w / iw, box.h / ih);
    const dw = iw * scale;
    const dh = ih * scale;
    return { place: { x: box.x + (box.w - dw) / 2, y: box.y + (box.h - dh) / 2, w: dw, h: dh } };
  }
  // cover
  const scale = Math.max(box.w / iw, box.h / ih);
  const sw = box.w / scale;
  const sh = box.h / scale;
  return {
    place: { ...box },
    crop: { sx: (iw - sw) / 2, sy: (ih - sh) / 2, sw, sh },
  };
}
